import { rgba, tint } from 'polished'
import styled, { css, keyframes } from 'styled-components'

export type LinearLoaderVariant = 'shimmer' | 'skeleton'

const shimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`

export interface ILinearLoaderStyledProps {
  variant: LinearLoaderVariant
  color: string
  width: string | number
  height: number
  borderRadius: number
  inverted: boolean
}

const shimmerBackground = (color: string) => css`
  background: ${tint(0.7, color)};
  background-image: linear-gradient(
    90deg,
    ${tint(0.45, color)} 0%,
    ${tint(0.85, color)} 50%,
    ${tint(0.45, color)} 100%
  );
`

const skeletonBackground = (inverted: boolean) => {
  const base = inverted ? 255 : 0

  return css`
    background-image: linear-gradient(
      90deg,
      ${rgba(base, base, base, 0.05)} 0%,
      ${rgba(base, base, base, 0.1)} 50%,
      ${rgba(base, base, base, 0.05)} 100%
    );
  `
}

export const LinearLoaderStyled = styled.div<ILinearLoaderStyledProps>`
  width: ${(props) =>
    typeof props.width === 'number'
      ? props.theme.typography.pxToRem(props.width)
      : props.width};
  height: ${(props) => props.theme.typography.pxToRem(props.height)};
  border-radius: ${(props) =>
    props.theme.typography.pxToRem(props.borderRadius)};
  overflow: hidden;
  ${(props) =>
    props.variant === 'skeleton'
      ? skeletonBackground(props.inverted)
      : shimmerBackground(props.color)}
  background-size: 200% 100%;
  animation: ${shimmer} 1.6s linear infinite;
`
